import React from 'react';
import './home.css'
import Headerr from '../components/layout/header';
import Sec1home from '../sections/sec1-home';
import Sec2home from '../sections/sec2-home';
import Navbar from '../components/layout/navbar';
import { useState } from 'react';
import { useEffect } from 'react';
import Preloader from '../components/common/preloader';

const Home = () => {
      const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />
    return ( 
        <>  
            <main className='home-background'>

                    <Headerr />
                    <Sec1home />
                    <Sec2home />
                    <Navbar />

            </main>
        </>
     );
}
 
export default Home;